module.exports = __webpack_public_path__ + "img/b3a2d0797eef37aa974cca4289348139.svg";